export default {"src":"/_next/static/media/microsoft.c37994f2.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};